import PanelTransitions from '@component/panel/transition';

export default class Transition extends PanelTransitions {
  enableTransitions() {
    this.component.classList.remove('transfer--no-transition');
  }

  hiddenToPage() {
    if (!this.animate) {
      this.component.className = 'transfer transfer--no-transition';
    }

    this.component.classList.add('transfer--full-panel');
    return [
      new Promise((resolve) => {
        const actualResolve = () => {
          this.enableTransitions();
          resolve();
        };

        this.exitResolve = actualResolve;
        this.exitTimeout = setTimeout(actualResolve, this.settings.duration);
      }),
    ];
  }

  hiddenToPlus() {
    if (!this.animate) {
      this.component.className = 'transfer transfer--no-transition';
    }

    this.component.classList.add('transfer--half-panel');
    return [
      new Promise((resolve) => {
        const actualResolve = () => {
          this.enableTransitions();
          resolve();
        };

        this.exitResolve = actualResolve;
        this.exitTimeout = setTimeout(actualResolve, this.settings.duration);
      }),
    ];
  }

  plusToPage() {
    this.component.classList.remove('transfer--half-panel');
    this.component.classList.add('transfer--full-panel');
    return [];
  }

  pageToPlus() {
    this.component.classList.remove('transfer--full-panel');
    this.component.classList.add('transfer--half-panel');
    return [];
  }

  anyToHidden() {
    this.component.classList.remove('transfer--half-panel');
    this.component.classList.remove('transfer--full-panel');
    return [
      new Promise((resolve) => {
        this.exitResolve = resolve;
        this.exitTimeout = setTimeout(resolve, this.settings.duration);
      }),
    ];
  }
}
